import requester from '@/lib/axios';
import { OrderingColumn } from '@/models/Question';
import { MULTIPART_FORM_DATA_HEADERS as headers } from '@/constants';
import { jsonToFormData } from '@/utils/shared/jsonToFormData';
import { FlowColumn } from '@/models/Question';
import { OrderingItemCreateDTO } from '@/models/Answer';

const baseUrl = 'dnd-ordenation-column';

type ColumnCreatePayload = {
  dndOrdenationActivity: number;
  name: string;
  flow: FlowColumn;
  items: OrderingItemCreateDTO[];
};

type ColumnUpdatePayload = {
  flow?: FlowColumn;
  items?: OrderingItemCreateDTO[];
};

export const createOrderingColumn = async (body: ColumnCreatePayload) => {
  const formData = jsonToFormData(body);
  const { data } = await requester().post<OrderingColumn>(
    `${baseUrl}/`,
    formData,
    { headers },
  );
  return data;
};

export const updateOrderingColumn = async (
  id: number,
  changes: ColumnUpdatePayload,
) => {
  const formData = jsonToFormData(changes);
  const { data } = await requester().patch<OrderingColumn>(
    `${baseUrl}/${id}/`,
    formData,
    { headers },
  );
  return data;
};
